import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-cart",
  "use": "icon-cart-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-cart\">\n  <defs>\n    <style type=\"text/css\"></style>\n  </defs>\n  <path d=\"M880 760h-0.18l-576.07-3.18a63.79 63.79 0 0 1-63.55-57.18l-61.11-488.76-57.37-11.5a32 32 0 0 1 12.55-62.76l57.37 11.47a63.91 63.91 0 0 1 51 54.87L303.75 692q0 0.39 0.09 0.79h0.16L880.18 696a32 32 0 0 1-0.17 64z\" p-id=\"3509\" />\n  <path d=\"M400 616a32 32 0 0 1-2.32-63.92l434.5-32c0-0.28 0-0.55 0.07-0.82L864 248H320a32 32 0 0 1 0-64h544a64 64 0 0 1 63.74 69.79q0 0.41-0.09 0.83l-31.83 271.74a63.79 63.79 0 0 1-59 57.55l-434.51 32c-0.76 0.09-1.56 0.09-2.31 0.09z m495.9-365.1z\" p-id=\"3510\" />\n  <path d=\"M368 840m-48 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0Z\" p-id=\"3511\" />\n  <path d=\"M816 840m-48 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0Z\" p-id=\"3512\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon/cart.svg
// module id = Iago
// module chunks = 55